import axios from "axios";
import { getCustomerNumber } from '../../Utils/Utils';

export const errorLogger = async (message, rc, shouldRedirect = true) => {
    const redirectLink = `/apps/jcom/router.mvc?error=true&errorGroupName=${rc}`;

    try {
        const options = {
            customerNumber: getCustomerNumber(),
            appCustomer: "stole-builder-consumer-ui",
            src: window.location.href,
            occTimestamp: new Date().toString(),
            appEnvironment: navigator.userAgent,
            faultDetails: message
        };

        await axios.post('/apps/store/bummer.mvc', options);

        if(shouldRedirect){
            window.location.href = redirectLink;
        }

    } catch (error) {
        console.error("Unable to call bummer.mvc for 404 logging:" + error);

        if (window.location.hostname !== "localhost" && shouldRedirect) {
            window.location.href = redirectLink;
        }
    }
}